import * as ko from "knockout";

export class CustomerReportsSearchCriteria {
  page_dir: KnockoutObservable<string>;
  sort_dir: KnockoutObservable<string>;
  sort_field: KnockoutObservable<string>;
  Page: KnockoutObservable<number>;
  Rows: KnockoutObservable<number>;
  generalSearch: KnockoutObservable<string>;
  viewName: KnockoutObservable<string>;
  serial_id: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;

  constructor(item) {
    this.Page = ko.observable(item.Page || 0);
    this.Rows = ko.observable(item.Rows || 15);
    this.page_dir = ko.observable(item.page_dir);
    this.sort_dir = ko.observable(item.sort_dir);
    this.sort_field = ko.observable(item.sort_field);
    this.generalSearch = ko.observable(item.generalSearch);
    this.viewName = ko.observable(item.viewName);
    this.serial_id = ko.observable(item.serial_id);
    this.model_id = ko.observable(item.model_id);
  }
}
